import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseServiceService } from '../../services/base-service.service';
import { ModalNotifyComponent, ModalNotifyTypes } from '../modal-notify/modal-notify.component';
import {
  ReporteriaService,
  ReporteFilaResponseDTO,
  ConfiguracionReporteColumnaResponseDTO,
  ReporteriaProcesoFrontendMeta,
  ReporteriaColumnaFrontendMeta,
  HistoricoSpConfiguracionDTO
} from '../../services/reporteria.service';

declare var fabric: any;

interface ColumnaReporteUI {
  NombreVariable: string;
  Etiqueta: string;
  Orden: number;
  VisibleEnTabla: boolean;
  TipoControl: 'input' | 'areatext';
  EsCampoNativo: boolean;
  ColumnaReferenciaVista?: string;
}

@Component({
  selector: 'app-reporteria-visor',
  templateUrl: './reporteria-visor.component.html',
  styleUrl: './reporteria-visor.component.css'
})
export class ReporteriaVisorComponent implements OnInit {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  procesosDisponibles: any[] = [];
  idProcesoSeleccionado: number | null = null;
  cargandoProcesos = false;
  cargandoDatos = false;
  descargandoExcel = false;
  descargandoExcelHistorico = false;

  dialogComponentConsulta: any = null;
  dialogComponentHistorico: any = null;
  filaConsulta: ReporteFilaResponseDTO | null = null;
  historialActual: any[] = [];
  historialCargando = false;
  mostrarHistorico = false;
  columnasVisiblesHistorico: ColumnaReporteUI[] = [];
  modoHistoricoActual: 'default' | 'sp' = 'default';
  configuracionHistoricoSpActual: HistoricoSpConfiguracionDTO[] = [];
  idEjecucionHistoricoActual: number | null = null;
  nombreSpHistoricoActual = '';
  nombreProcesoSeleccionado = '';
  tipoOrigenActual: 'Variables' | 'Vista' = 'Variables';
  habilitarBusquedaFechas = false;
  habilitarHistorico = false;
  columnaFechaVistaConfig = '';
  metaFrontendActual: ReporteriaProcesoFrontendMeta | null = null;

  // Filtros
  fechaDesde = '';
  fechaHasta = '';
  incluirHistoricos = false;
  ordenDescendente = true;

  // Datos del reporte
  columnas: ConfiguracionReporteColumnaResponseDTO[] = [];
  columnasConfiguradas: ColumnaReporteUI[] = [];
  columnasVisiblesTabla: ColumnaReporteUI[] = [];
  filas: ReporteFilaResponseDTO[] = [];
  recordsTotal = 0;
  recordsFiltered = 0;

  // Paginación
  pageSize = 10;
  currentPage = 1;
  pageSizeOptions = [5, 10, 25, 50];

  // Estado UI
  reporteCargado = false;
  columnasSinConfig = false;

  constructor(
    private reporteriaService: ReporteriaService,
    private baseService: BaseServiceService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.cargarProcesos();
  }

  async cargarProcesos(): Promise<void> {
    this.cargandoProcesos = true;
    try {
      const response = await this.reporteriaService.getProcesosConConfiguracion();
      if (response && response.Data) {
        this.procesosDisponibles = response.Data || [];
      }
    } catch (error) {
      this.baseService.triggerShowModal('Error', 'No se pudieron cargar los procesos.', ModalNotifyTypes.Danger, false);
    } finally {
      this.cargandoProcesos = false;
    }
  }

  onProcesoChange(): void {
    const proceso = this.procesosDisponibles.find((p: any) => Number(p.Id) === Number(this.idProcesoSeleccionado));
    this.nombreProcesoSeleccionado = proceso?.Nombre || '';

    this.metaFrontendActual = this.obtenerFrontendMeta();
    if (this.metaFrontendActual) {
      this.habilitarBusquedaFechas = !!this.metaFrontendActual.HabilitarBusquedaFechas;
      this.columnaFechaVistaConfig = this.metaFrontendActual.ColumnaFechaVista || '';
      this.habilitarHistorico = this.metaFrontendActual.HabilitarHistorico ?? false;
      this.tipoOrigenActual = this.metaFrontendActual.TipoOrigen || 'Variables';
      this.modoHistoricoActual = this.metaFrontendActual.ModoHistorico || 'default';
      this.configuracionHistoricoSpActual = this.metaFrontendActual.ConfiguracionHistoricoSp || [];
    } else {
      this.habilitarBusquedaFechas = false;
      this.columnaFechaVistaConfig = '';
      this.habilitarHistorico = false;
      this.tipoOrigenActual = 'Variables';
      this.modoHistoricoActual = 'default';
      this.configuracionHistoricoSpActual = [];
    }

    if (!this.habilitarBusquedaFechas) {
      this.fechaDesde = '';
      this.fechaHasta = '';
    }

    this.reporteCargado = false;
    this.columnasSinConfig = false;
    this.columnas = [];
    this.columnasConfiguradas = [];
    this.columnasVisiblesTabla = [];
    this.filas = [];
    this.currentPage = 1;
  }

  async buscarReporte(): Promise<void> {
    if (!this.idProcesoSeleccionado) {
      this.baseService.triggerShowModal('Validación', 'Seleccione un proceso para continuar.', ModalNotifyTypes.Warning, false);
      return;
    }
    this.currentPage = 1;
    await this.cargarDatos();
  }

  async cargarDatos(): Promise<void> {
    if (!this.idProcesoSeleccionado) return;

    this.cargandoDatos = true;
    this.reporteCargado = false;
    this.columnasSinConfig = false;

    try {
      const body = this.construirBodyReporte((this.currentPage - 1) * this.pageSize, this.pageSize);

      const response = await this.reporteriaService.getDatosReporte(body);

      if (!response.Ok) {
        const msg = response.Error || 'Error al cargar el reporte.';
        this.baseService.triggerShowModal('Error', msg, ModalNotifyTypes.Danger, false);
        return;
      }

      const data = response.Data;
      this.columnas = ((data.Columnas || []) as ConfiguracionReporteColumnaResponseDTO[])
        .sort((a, b) => a.Orden - b.Orden);

      if (this.columnas.length > 0) {
        this.tipoOrigenActual = this.columnas[0].TipoOrigen || this.tipoOrigenActual;
        this.habilitarHistorico = !!this.columnas[0].HabilitarHistorico;
        this.modoHistoricoActual = this.columnas[0].ModoHistorico || 'default';
        this.configuracionHistoricoSpActual = this.columnas[0].ConfiguracionHistoricoSp || [];
      }

      this.reconstruirColumnasUI();
      this.filas = data.Filas || [];
      this.recordsTotal = data.RecordsTotal || 0;
      this.recordsFiltered = data.RecordsFiltered || 0;
      this.reporteCargado = true;

      if (this.columnas.length === 0) {
        this.columnasSinConfig = true;
      }
    } catch (error: any) {
      this.baseService.triggerShowModal('Error', error?.error?.Error || 'Error inesperado al cargar el reporte.', ModalNotifyTypes.Danger, false);
    } finally {
      this.cargandoDatos = false;
    }
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.recordsFiltered / this.pageSize));
  }

  get pages(): number[] {
    const total = this.totalPages;
    const current = this.currentPage;
    const delta = 2;
    const start = Math.max(1, current - delta);
    const end = Math.min(total, current + delta);
    const result: number[] = [];
    for (let i = start; i <= end; i++) result.push(i);
    return result;
  }

  async goToPage(page: number): Promise<void> {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    await this.cargarDatos();
  }

  async onPageSizeChange(): Promise<void> {
    this.currentPage = 1;
    await this.cargarDatos();
  }

  getValorColumna(fila: ReporteFilaResponseDTO, columna: ColumnaReporteUI, forInput = false): string {
    return this.getValorColumnaGenerica(fila as any, columna, forInput);
  }

  getValorColumnaGenerica(fila: any, columna: ColumnaReporteUI, forInput = false): string {
    let value: any = fila.Valores?.[columna.NombreVariable];

    if ((value === null || value === undefined) && columna.EsCampoNativo) {
      if (this.tipoOrigenActual === 'Vista' && columna.ColumnaReferenciaVista?.trim()) {
        value = fila.Valores?.[columna.ColumnaReferenciaVista.trim()];
      } else {
        switch (columna.NombreVariable) {
          case '__SYS_ID_EJECUCION':
          case 'IdEjecucion':
            value = fila.IdEjecucion ?? (fila as any).IdEjecucionProcesoDetalle;
            break;
          case '__SYS_ESTADO':
          case 'Estado':
            value = fila.Estado ?? (fila as any).EstadoEjecucion;
            break;
          case '__SYS_TIPO':
          case 'Tipo':
            value = fila.EsHistorico === true ? 'Finalizado' : 'Activo';
            break;
          case '__SYS_USUARIO_INICIA':
          case 'UsuarioInicia':
            value = fila.UsuarioInicia;
            break;
          case '__SYS_FECHA_INICIA':
          case 'FechaInicia':
            value = fila.FechaInicia ?? (fila as any).FechaInicia;
            break;
          case '__SYS_FECHA_FINALIZA':
          case 'FechaFinaliza':
            value = fila.FechaFinaliza ?? (fila as any).FechaFinaliza;
            break;
          default:
            break;
        }
      }
    }

    if (value === null || value === undefined || value === '') {
      return forInput ? '' : '—';
    }

    if (columna.NombreVariable.includes('FECHA') || columna.Etiqueta.toLowerCase().includes('fecha')) {
      return this.formatearFecha(value);
    }

    return String(value);
  }

  abrirConsulta(fila: any): void {
    this.filaConsulta = fila as ReporteFilaResponseDTO;
    const dialog = document.querySelector('.modal-consulta-reporteria');
    this.dialogComponentConsulta = new fabric['Dialog'](dialog);
    this.dialogComponentConsulta.open();
  }

  async abrirHistorico(fila: ReporteFilaResponseDTO): Promise<void> {
    if (!this.habilitarHistorico) return;

    const idEjecucionRaw = fila.IdEjecucion ?? (fila as any).Valores?.['IdEjecucion'];
    const idEjecucion = Number(idEjecucionRaw);
    if (!idEjecucion) return;

    let nombreSp = '';
    if (this.modoHistoricoActual === 'sp') {
      if (this.configuracionHistoricoSpActual.length === 0) {
        this.baseService.triggerShowModal('Error', 'Este proceso no tiene un SP de histórico configurado.', ModalNotifyTypes.Danger, false);
        return;
      }
      nombreSp = this.configuracionHistoricoSpActual[0].NombreSp;
    }

    this.historialCargando = true;
    this.historialActual = [];
    this.mostrarHistorico = false;
    this.idEjecucionHistoricoActual = idEjecucion;
    this.nombreSpHistoricoActual = nombreSp;

    try {
      const response = this.modoHistoricoActual === 'sp'
        ? await this.reporteriaService.getHistoricoEjecucionSp(idEjecucion, nombreSp)
        : await this.reporteriaService.getHistoricoEjecucion(idEjecucion);

      if (!response?.Ok) {
        this.baseService.triggerShowModal('Error', response?.Error || 'No fue posible cargar el histórico.', ModalNotifyTypes.Danger, false);
        return;
      }

      // El backend devuelve { Columnas, Filas } (mismo patrón que GetDatosReporte) para poder
      // resolver la Etiqueta configurada sin correlacionar con otra llamada.
      const columnasHistorico: ColumnaReporteUI[] = ((response.Data?.Columnas || []) as ConfiguracionReporteColumnaResponseDTO[])
        .slice()
        .sort((a, b) => a.Orden - b.Orden)
        .map((c, index) => ({
          NombreVariable: c.NombreVariable,
          Etiqueta: c.Etiqueta,
          Orden: index,
          VisibleEnTabla: c.VisibleEnTabla,
          TipoControl: c.TipoControl,
          EsCampoNativo: c.EsCampoNativo,
          ColumnaReferenciaVista: c.ColumnaReferenciaVista || ''
        }));

      this.columnasVisiblesHistorico = columnasHistorico.length > 0
        ? columnasHistorico.filter(c => c.VisibleEnTabla)
        : this.columnasVisiblesTabla;

      this.historialActual = response.Data?.Filas || [];
      this.mostrarHistorico = true;
    } catch (error: any) {
      this.baseService.triggerShowModal('Error', error?.error?.Error || 'No fue posible cargar el histórico.', ModalNotifyTypes.Danger, false);
    } finally {
      this.historialCargando = false;
    }
  }

  cerrarConsulta(): void {
    try {
      this.dialogComponentConsulta?.close();
    } catch {
      // no-op
    } finally {
      this.dialogComponentConsulta = null;
      this.filaConsulta = null;
    }
  }

  cerrarHistorico(): void {
    this.mostrarHistorico = false;
    this.historialActual = [];
    this.columnasVisiblesHistorico = [];
    this.dialogComponentHistorico = null;
    this.idEjecucionHistoricoActual = null;
    this.nombreSpHistoricoActual = '';
  }

  async descargarExcel(): Promise<void> {
    if (!this.idProcesoSeleccionado) {
      this.baseService.triggerShowModal('Validación', 'Seleccione un proceso para exportar.', ModalNotifyTypes.Warning, false);
      return;
    }

    this.descargandoExcel = true;
    try {
      const body = this.construirBodyReporte(0, 0);
      const blob = await this.reporteriaService.exportarExcel(body);

      if (!blob || !(blob instanceof Blob) || blob.size === 0) {
        this.baseService.triggerShowModal('Sin datos', 'No hay datos para exportar con los filtros actuales.', ModalNotifyTypes.Warning, false);
        return;
      }

      const nombre = (this.nombreProcesoSeleccionado || 'Reporte').replace(/\s+/g, '_');
      const stamp = this.getDateStamp();
      this.descargarBlob(blob, `Reporte_${nombre}_${stamp}.xlsx`);
    } catch (error: any) {
      const mensaje = await this.obtenerMensajeErrorBlob(error, 'No fue posible exportar el archivo de Excel.');
      this.baseService.triggerShowModal('Error', mensaje, ModalNotifyTypes.Danger, false);
    } finally {
      this.descargandoExcel = false;
    }
  }

  async descargarExcelHistorico(): Promise<void> {
    if (!this.idEjecucionHistoricoActual) {
      this.baseService.triggerShowModal('Validación', 'No hay una ejecución de histórico activa para exportar.', ModalNotifyTypes.Warning, false);
      return;
    }
    if (this.historialActual.length === 0) {
      this.baseService.triggerShowModal('Sin datos', 'No hay datos de histórico para exportar.', ModalNotifyTypes.Warning, false);
      return;
    }

    this.descargandoExcelHistorico = true;
    try {
      const body: { IdEjecucionProceso: number; NombreSp?: string } = {
        IdEjecucionProceso: this.idEjecucionHistoricoActual
      };
      if (this.modoHistoricoActual === 'sp' && this.nombreSpHistoricoActual) {
        body.NombreSp = this.nombreSpHistoricoActual;
      }

      const blob = await this.reporteriaService.exportarExcelHistorico(body);
      if (!blob || !(blob instanceof Blob) || blob.size === 0) {
        this.baseService.triggerShowModal('Sin datos', 'No hay datos de histórico para exportar.', ModalNotifyTypes.Warning, false);
        return;
      }

      const nombre = (this.nombreProcesoSeleccionado || 'Historico').replace(/\s+/g, '_');
      this.descargarBlob(blob, `Historico_${nombre}_${this.idEjecucionHistoricoActual}.xlsx`);
    } catch (error: any) {
      const mensaje = await this.obtenerMensajeErrorBlob(error, 'No fue posible exportar el histórico a Excel.');
      this.baseService.triggerShowModal('Error', mensaje, ModalNotifyTypes.Danger, false);
    } finally {
      this.descargandoExcelHistorico = false;
    }
  }

  limpiarFiltros(): void {
    this.fechaDesde = '';
    this.fechaHasta = '';
    this.incluirHistoricos = false;
    this.ordenDescendente = true;
    this.currentPage = 1;
    this.reporteCargado = false;
    this.columnasSinConfig = false;
    this.columnas = [];
    this.columnasConfiguradas = [];
    this.columnasVisiblesTabla = [];
    this.filas = [];
    this.idProcesoSeleccionado = null;
    this.nombreProcesoSeleccionado = '';
    this.cerrarConsulta();
  }

  private reconstruirColumnasUI(): void {
    const columnasBackendOrdenadas = [...this.columnas].sort((a, b) => a.Orden - b.Orden);
    const columnasUI: ColumnaReporteUI[] = [];
    const incluidos = new Set<string>();

    const metaCols = [...(this.metaFrontendActual?.Columnas || [])].sort((a, b) => a.Orden - b.Orden);
    const backendMap = new Map(columnasBackendOrdenadas.map(c => [c.NombreVariable, c]));

    if (metaCols.length > 0) {
      metaCols.forEach((metaCol) => {
        if (!metaCol.EsCampoNativo && !backendMap.has(metaCol.NombreVariable)) {
          return;
        }

        columnasUI.push({
          NombreVariable: metaCol.NombreVariable,
          Etiqueta: metaCol.Etiqueta || this.getNombreLegible(metaCol.NombreVariable),
          Orden: columnasUI.length,
          VisibleEnTabla: metaCol.VisibleEnTabla !== false,
          TipoControl: metaCol.TipoControl || 'input',
          EsCampoNativo: metaCol.EsCampoNativo,
          ColumnaReferenciaVista: metaCol.ColumnaReferenciaVista || ''
        });
        incluidos.add(metaCol.NombreVariable);
      });
    }

    columnasBackendOrdenadas.forEach((col) => {
      if (incluidos.has(col.NombreVariable)) return;
      columnasUI.push({
        NombreVariable: col.NombreVariable,
        Etiqueta: col.Etiqueta,
        Orden: columnasUI.length,
        VisibleEnTabla: true,
        TipoControl: 'input',
        EsCampoNativo: false,
        ColumnaReferenciaVista: ''
      });
    });

    this.columnasConfiguradas = columnasUI;
    this.columnasVisiblesTabla = columnasUI.filter(c => c.VisibleEnTabla);
  }

  private construirBodyReporte(skip: number, pageSize: number): any {
    const body: any = {
      IdProceso: Number(this.idProcesoSeleccionado),
      Skip: skip,
      PageSize: pageSize,
      IncluirHistoricos: this.incluirHistoricos,
      OrdenDescendente: this.ordenDescendente
    };

    if (this.habilitarBusquedaFechas) {
      if (this.fechaDesde) body.FechaDesde = this.fechaDesde;
      if (this.fechaHasta) body.FechaHasta = this.fechaHasta;
      if (this.tipoOrigenActual === 'Vista' && this.columnaFechaVistaConfig?.trim()) {
        body.ColumnaFechaVista = this.columnaFechaVistaConfig.trim();
      }
    }

    return body;
  }

  private descargarBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  private async obtenerMensajeErrorBlob(error: any, mensajePorDefecto: string): Promise<string> {
    if (error?.error instanceof Blob) {
      try {
        const texto = await error.error.text();
        const parsed = JSON.parse(texto);
        return parsed?.Error || mensajePorDefecto;
      } catch {
        return mensajePorDefecto;
      }
    }
    return error?.error?.Error || mensajePorDefecto;
  }

  private obtenerStorageKey(): string {
    return `bsp_reporteria_front_meta_${this.idProcesoSeleccionado}`;
  }

  private obtenerFrontendMeta(): ReporteriaProcesoFrontendMeta | null {
    try {
      const raw = localStorage.getItem(this.obtenerStorageKey());
      if (!raw) return null;
      return JSON.parse(raw) as ReporteriaProcesoFrontendMeta;
    } catch {
      return null;
    }
  }

  private formatearFecha(value: any): string {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
  }

  private getNombreLegible(nombreVariable: string): string {
    const legibles: Record<string, string> = {
      '__SYS_ID_EJECUCION': 'Id Ejecución',
      '__SYS_ESTADO': 'Estado',
      '__SYS_TIPO': 'Tipo',
      '__SYS_USUARIO_INICIA': 'Usuario inicia',
      '__SYS_FECHA_INICIA': 'Fecha inicia',
      '__SYS_FECHA_FINALIZA': 'Fecha finaliza',
      'IdEjecucion': 'Id Ejecución',
      'Estado': 'Estado',
      'Tipo': 'Tipo',
      'UsuarioInicia': 'Usuario inicia',
      'FechaInicia': 'Fecha inicia',
      'FechaFinaliza': 'Fecha finaliza'
    };
    return legibles[nombreVariable] || nombreVariable;
  }

  private getDateStamp(): string {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const mi = String(now.getMinutes()).padStart(2, '0');
    return `${yyyy}${mm}${dd}_${hh}${mi}`;
  }
}
